export default {
  'menu.home': '首页',
  'menu': '今日商城',
  'menu.todayggigu': '今日直购',
  'menu.login': '登录',
  'menu.logout': '退出登录',
  'menu.products': '运营管理',
  'menu.products.operation-data': '运营数据',
  'menu.products.list': '公司商城',
  'menu.cs.suggestion': '场地评估',
  'menu.products.edit': '编辑商品',
  'menu.products.add': '添加商品',
  'menu.products.import-taobao': '从推广网址导入',
  'menu.products.categories': '分类管理',
  'menu.products.stores': '店铺管理',
  'menu.products.live-sellers': '直播卖家',
  'menu.products.live-sellers.sellers': '卖家列表',
  'menu.products.coupon-point-settings': '积分/优惠券设置',
  'menu.cs.notices': '公告',
  'menu.products.search-management': '搜索管理',
  'menu.products.search-management.danger-management': '危险词管理',
  'menu.products.search-management.edit-search-term': '编辑搜索词',
  'menu.operations': '运营管理',
  'menu.operations.operation-data': '运营数据',
  'menu.operations.list': '公司商城',
  'menu.operations.add': '添加商品',
  'menu.operations.edit': '编辑商品',
  'menu.operations.import-taobao': '从推广网址导入',
  'menu.operations.categories': '分类管理',
  'menu.operations.stores': '店铺管理',
  'menu.operations.promo-videos': '宣传视频审核',
  'menu.operations.live': '直播',
  'menu.operations.live.live-sellers': '直播卖家',
  'menu.operations.live.live-team-list': '直播团队列表',
  'menu.operations.live.live-rebate-settings': '直播返利设置',
  'menu.operations.live.live-page-settings': '直播页面设置',
  'menu.operations.live.seller-detail': '卖家详情',
  'menu.operations.live-sellers': '直播卖家',
  'menu.operations.live-team-list': '直播团队列表',
  'menu.operations.live-page-settings': '直播页面设置',
  'menu.operations.frontend-pages': '前台页面设置',
  'menu.operations.seller-detail': '卖家详情',
  'menu.operations.rebate-settings': '返利设置',
  'menu.operations.rebate-settings.rebate-level': '返利等级',
  'menu.operations.rebate-settings.rebate-rules': '返利规则',
  'menu.operations.live-rebate-settings': '直播返利设置',
  'menu.operations.store-rebate-settings': '店铺返利设置',
  'menu.operations.share-rebate-settings': '分享返利设置',
  'menu.operations.coupon-point-settings': '积分/优惠券设置',
  'menu.operations.search-management': '搜索管理',
  'menu.operations.search-management.danger-management': '危险词管理',
  'menu.operations.search-management.edit-search-term': '编辑搜索词',
  'menu.orders': '订单管理',
  'menu.orders.user': '普通会员订单',
  'menu.orders.pending-payment': '待付款',
  'menu.orders.no-data': '无数据',
  'menu.orders.questions': '订单咨询',
  'menu.todayggigu.orders.tradeServices': '贸易服务',
  'menu.todayggigu.orders.tradeServices.comprehensive': '综合管理',
  'menu.todayggigu.orders.tradeServices.pendingPayment': '待付款',
  'menu.todayggigu.orders.paymentAgency': '支付代理',
  'menu.todayggigu.orders.paymentAgency.comprehensive': '综合管理',
  'menu.todayggigu.orders.paymentAgency.pendingPayment': '待付款',
  'menu.todayggigu.orders.paymentAgency.forexDepositApplication': '外汇押金申请详情',
  'menu.todayggigu.orders.paymentAgency.forexDepositUsage': '外汇押金使用详情',
  'menu.todayggigu.orders.paymentAgency.forexDepositPayment': '外汇押金支付详情',
  'menu.orders.statistics': '订单统计',
  'menu.storehouse': '仓库管理',
  'menu.storehouse.express-inspection': '快递入库检验',
  'menu.storehouse.non-master-courier': '非主流快递入库',
  'menu.storehouse.inspection-list': '检验列表',
  'menu.storehouse.rack': '货架管理',
  'menu.storehouse.inventory': '库存管理',
  'menu.storehouse.inventory-detail': '仓库详情',
  'menu.storehouse.warehouse-address': '仓库地址',
  'menu.storehouse.waybill-informations': '运单信息',
  'menu.storehouse.waybill-bandwidth-management': '运单带宽管理',
  'menu.storehouse.transportation-methods': '运输方式',
  'menu.storehouse.logistics-trajectory': '物流轨迹',
  'menu.storehouse.regional-management': '区域管理',
  'menu.storehouse.international-tracking-number-management': '国际运单号管理',
  'menu.storehouse.hs-product-code-management': 'HS 商品代码管理',
  'menu.members': '会员管理',
  'menu.members.general': '普通会员',
  'menu.members.blacklist': '黑名单会员',
  'menu.members.statistics': '会员统计',
  'menu.members.active-users': '活跃用户',
  'menu.members.membershipLevelManagement': '会员等级管理',
  // RebateLevel, RebateRules, FinancialRecord, Deposit moved to settlement/settings
  'menu.members.rechargeReview': '充值审核',
  'menu.members.withdrawReview': '提现审核',
  'menu.members.userPromotionDetail': '用户促销详情',
  'menu.members.memberDocuments': '会员文件管理',
  'menu.members.consumptionChangeDetails': '消费变更详情',
  'menu.members.coupon-point-settings': '优惠券积分设置',
  'menu.statistics': '统计',
  'menu.statistics.visit-analytics': '访问·点击分析',
  'menu.settlement': '财务管理',
  'menu.settlement.sellers': '卖家结算',
  'menu.settlement.dashboard': '仪表盘',
  'menu.settlement.platform': '平台费用',
  'menu.settlement.deposit-application-history': '存款申请历史',
  'menu.settlement.deposit-usage-history': '存款使用记录',
  'menu.settlement.rebate-rules': '返利规则',
  'menu.settlement.rebate-levels': '返利等级',
  'menu.settlement.financial-tax-report': '财务税务报告',
  'menu.settlement.financial-record': '财务记录',
  'menu.settlement.deposit': '存款管理',
  'menu.settlement.pending-payment': '待付款',
  'menu.settlement.share-rebates': '分享返利',
  'menu.settings': '设置',
  'menu.settings.rebate-level': '返利等级',
  'menu.settings.rebate-rules': '返利规则',
  'menu.settings.product-price-increase': '商品价格上调',
  'menu.settings.service-fee': '服务费',
  'menu.settings.website-content-management': '网站内容管理',
  'menu.settings.website-content-management.seo-settings': '网站SEO设置',
  'menu.settings.website-content-management.email-configuration': '邮件配置',
  'menu.settings.website-content-management.image-settings': '图片设置',
  'menu.settings.website-content-management.basic-configuration': '网站基本配置',
  'menu.settings.website-content-management.app-settings': '应用设置',
  'menu.settings.mail-management': '邮件管理',
  'menu.settings.mail-management.email-template': '邮件模板',
  'menu.settings.mail-management.sms-template': '短信模板',
  'menu.settings.mail-management.email-log': '邮件日志',
  'menu.settings.mail-management.push-message': '推送消息',
  // 'menu.system-settings': '系统设置',
  'menu.settings.admins': '管理员账户',
  'menu.settings.rates': '汇率/关税设置',
  'menu.settings.purchase-condition-settings': '购买条件设置',
  'menu.settings.additional-cost-settings': '附加费用设置',
  'menu.settings.additional-service': '附加服务',
  'menu.settings.shipping-rate': '配送费率',
  'menu.settings.work-log': '工作日志',
  'menu.settings.island-mountain-cost': '岛屿/山区费用',
  'menu.cs': '客服管理',
  'menu.cs.inquiries': '1对1咨询',
  'menu.cs.faq': '常见问题',
  'menu.cs.help': '帮助中心',
  'menu.cs.banners': '横幅/活动',
  'menu.todayggigu.cs.event': '活动',
  // Search Management and Mail Management moved to settings
  'menu.cs.looking-for-owner': '寻找业主',
  'menu.cs.reviews': '用户评论',
  'menu.cs.review-write': '写评论',
  'menu.cs.review-detail': '评论详情',
  'menu.cs.review-edit': '编辑评论',
  'menu.todayggigu.orders': '订单管理',
  'menu.todayggigu.orders.business': '企业会员订单',
  'menu.todayggigu.orders.business.orders': '订单',
  'menu.todayggigu.orders.business.pending-payment': '待付款',
  'menu.todayggigu.orders.business.no-data': '无数据',
  'menu.todayggigu.orders.vvic': 'VVIC高通行订单',
  'menu.todayggigu.orders.vvic.orders': '订单',
  'menu.todayggigu.orders.vvic.pending-payment': '待付款',
  'menu.todayggigu.orders.vvic.no-data': '无数据',
  'menu.todayggigu.orders.rocket': '火箭订单',
  'menu.todayggigu.orders.rocket.orders': '订单',
  'menu.todayggigu.orders.rocket.pending-payment': '待付款',
  'menu.todayggigu.orders.rocket.no-data': '无数据',
  'menu.todayggigu.orders.pending-payment': '待付款',
  'menu.todayggigu.orders.statistics': '订单统计',
  'menu.todayggigu.orders.pending-address': '待填写地址',
  'menu.todayggigu.orders.in-china-warehouse': '中国仓库入库',
  'menu.todayggigu.orders.in-korea-delivery': '配送中',
  'menu.todayggigu.orders.completed': '配送完成',
  'menu.todayggigu.orders.no-data': '无数据',
  'menu.todayggigu.orders.questions': '订单咨询',
  'menu.todayggigu.orders.inventory-questions': '库存咨询',
  'menu.todayggigu.lowest-price-products': '最低价商品',
  'menu.todayggigu.lowest-price-products.list': '商品列表',
  'menu.todayggigu.lowest-price-products.category': '分类管理',
  'menu.todayggigu.homepage': '首页管理',
  'menu.todayggigu.homepage.main-rolling-banner': '主滚动横幅',
  'menu.todayggigu.homepage.banner-management': '横幅管理',
  'menu.todayggigu.homepage.recommended-products': '推荐商品',
  'menu.todayggigu.homepage.departure-schedule': '发货时间表',
  'menu.todayggigu.homepage.shopping-information': '购物信息',
  'menu.todayggigu.homepage.event-management': '活动管理',
  'menu.todayggigu.homepage.popup-management': '弹窗管理',
  'menu.todayggigu.homepage.page-management': '页面管理',
  'menu.todayggigu.homepage.mail-form-management': '邮件表单管理',
  'menu.todayggigu.coupon-management': '优惠券管理',
  'menu.todayggigu.coupon-management.issuance-details': '优惠券发放详情',
  'menu.todayggigu.coupon-management.coupon-issuance-details': '优惠券发放详情',
  'menu.todayggigu.coupon-management.event-coupon': '活动优惠券',
  'menu.todayggigu.sms': '短信管理',
  'menu.todayggigu.sms.send': '发送短信',
  'menu.todayggigu.sms.sending-history': '发送历史',
  'menu.todayggigu.sms.kakao-sms-management': 'Kakao短信管理',
  'menu.todayggigu.sms.point-details': '积分详情',
  'menu.todayggigu.environment-setting': '环境设置',
  'menu.todayggigu.environment-setting.membership-level': '会员等级',
  'menu.todayggigu.environment-setting.administrator-management': '管理员管理',
  'menu.todayggigu.environment-setting.center-management': '中心管理',
  'menu.todayggigu.environment-setting.shipping-rate': '运费',
  'menu.todayggigu.environment-setting.deposit-account': '存款账户',
  'menu.todayggigu.environment-setting.customs-exchange-rate': '关税汇率',
  'menu.todayggigu.environment-setting.applicable-exchange-rate': '适用汇率',
  'menu.todayggigu.environment-setting.additional-service': '附加服务',
  'menu.todayggigu.environment-setting.island-mountain-cost': '岛屿/山区费用',
  'menu.todayggigu.environment-setting.item-management': '项目管理',
  'menu.todayggigu.environment-setting.waybill-bandwidth': '运单带宽',
  'menu.todayggigu.members': '会员管理',
  'menu.todayggigu.members.business': '企业会员',
  'menu.todayggigu.members.blacklist': '黑名单会员',
  'menu.todayggigu.members.points': '积分',
  'menu.todayggigu.members.statistics': '会员统计',
  'menu.todayggigu.members.active-users': '活跃用户',
  'menu.todayggigu.members.membershipLevelManagement': '会员等级管理',
  'menu.todayggigu.members.rebateLevel': '返利等级',
  'menu.todayggigu.members.rebateRules': '返利规则',
  'menu.todayggigu.members.financialRecord': '财务记录',
  'menu.todayggigu.members.deposit': '存款管理',
  'menu.todayggigu.members.userPromotionDetail': '用户促销详情',
  'menu.todayggigu.members.consumptionChangeDetails': '消费变更详情',
  'menu.todayggigu.members.coupons': '优惠券管理',
  'menu.todayggigu.members.coupon-point-settings': '优惠券积分设置',
  'menu.todayggigu.members.depositApplication': '押金申请详情',
  'menu.todayggigu.members.depositUsage': '押金使用详情',
  'menu.todayggigu.members.bankbookVerification': '银行账户自动验证',
  'menu.todayggigu.members.forexDepositApplication': '外汇押金申请详情',
  'menu.todayggigu.members.forexDepositUsage': '外汇押金使用详情',
  'menu.todayggigu.members.forexDepositPayment': '外汇押金支付详情',
  'menu.todayggigu.settlement': '财务管理',
  'menu.todayggigu.settlement.sellers': '卖家结算',
  'menu.todayggigu.settlement.platform': '平台费用',
  'menu.todayggigu.settings': '设置',
  'menu.todayggigu.settings.rebate-level': '返利等级',
  'menu.todayggigu.settings.rebate-rules': '返利规则',
  'menu.todayggigu.settings.coupons': '积分/优惠券设置',
  'menu.todayggigu.settings.product-price-increase': '商品价格增加',
  'menu.todayggigu.settings.service-fee': '服务费',
  'menu.todayggigu.settings.search-management': '搜索管理',
  'menu.todayggigu.settings.search-management.danger-management': '危险词管理',
  'menu.todayggigu.settings.search-management.edit-search-term': '编辑搜索词',
  'menu.todayggigu.settings.mail-management.website-content-management': '网站内容管理',
  'menu.todayggigu.settings.website-content-management.seo-settings': '网站SEO设置',
  'menu.todayggigu.settings.website-content-management.email-configuration': '邮件配置',
  'menu.todayggigu.settings.website-content-management.image-settings': '图片设置',
  'menu.todayggigu.settings.website-content-management.basic-configuration': '网站基本配置',
  'menu.todayggigu.settings.website-content-management.app-settings': '应用设置',
  'menu.list': '列表',
  'menu.add': '添加',
  'menu.todayggigu.bulletin-board': '公告板管理',
  'menu.todayggigu.bulletin-board.event': '活动',
  'menu.todayggigu.bulletin-board.settings': '公告板设置',
  'menu.todayggigu.bulletin-board.inquiries': '1对1咨询',
  'menu.todayggigu.bulletin-board.inquiries.add': '添加咨询',
  'menu.todayggigu.bulletin-board.inquiries.edit': '编辑咨询',
  'menu.todayggigu.bulletin-board.notices': '公告',
  'menu.todayggigu.bulletin-board.notices.add': '添加公告',
  'menu.todayggigu.bulletin-board.notices.edit': '编辑公告',
  'menu.todayggigu.bulletin-board.faq': '常见问题',
  'menu.todayggigu.bulletin-board.faq.add': '添加常见问题',
  'menu.todayggigu.bulletin-board.faq.edit': '编辑常见问题',
  'menu.todayggigu.bulletin-board.help': '帮助中心',
  'menu.todayggigu.bulletin-board.banners': '活动',
  'menu.todayggigu.bulletin-board.looking-for-owner': '寻找失主',
  'menu.todayggigu.bulletin-board.looking-for-owner.add': '添加寻找失主',
  'menu.todayggigu.bulletin-board.looking-for-owner.edit': '编辑寻找失主',
  'menu.todayggigu.bulletin-board.reviews': '使用评价',
  'menu.todayggigu.bulletin-board.reviews.add': '添加评价',
  'menu.todayggigu.bulletin-board.reviews.edit': '编辑评价',
  'menu.todayggigu.bulletin-board.suggestion': '建议箱',
  'menu.todayggigu.bulletin-board.suggestion.add': '添加建议',
  'menu.todayggigu.bulletin-board.suggestion.edit': '编辑建议',
  'menu.todayggigu.bulletin-board.event.add': '添加活动',
  'menu.todayggigu.bulletin-board.event.edit': '编辑活动',
  'menu.todayggigu.bulletin-board.search-management': '搜索管理',
  'menu.todayggigu.bulletin-board.search-management.danger-management': '危险词管理',
  'menu.todayggigu.bulletin-board.search-management.edit-search-term': '编辑搜索词',
  'menu.todayggigu.bulletin-board.mail-management': '邮件管理',
  'menu.todayggigu.bulletin-board.mail-management.email-template': '邮件模板',
  'menu.todayggigu.bulletin-board.mail-management.sms-template': '短信模板',
  'menu.todayggigu.bulletin-board.mail-management.email-log': '邮件日志',
  'menu.todayggigu.bulletin-board.mail-management.push-message': '推送消息',
  'menu.todayggigu.settings.mail-management': '邮件管理',
  'menu.todayggigu.settings.mail-management.email-template': '邮件模板',
  'menu.todayggigu.settings.mail-management.sms-template': '短信模板',
  'menu.todayggigu.settings.mail-management.email-log': '邮件日志',
  'menu.todayggigu.settings.mail-management.push-message': '推送消息',
  'menu.todayggigu.system-settings': '系统设置',
  'menu.todayggigu.system-settings.admins': '管理员账户',
  'menu.todayggigu.system-settings.rates': '汇率/关税设置',
  'menu.todayggigu.system-settings.purchase-condition-settings': '购买条件设置',
  'menu.todayggigu.system-settings.shipping-rate': '配送费率',
  'menu.todayggigu.system-settings.work-log': '工作日志',
  'menu.todayggigu.bulletin-board.review-write': '写评论',
  'menu.todayggigu.bulletin-board.review-detail': '评论详情',
  'menu.todayggigu.bulletin-board.review-edit': '编辑评论',
  'menu.todayggigu.rack': '货架管理',
  'menu.todayggigu.rack.management': '货架管理',
  'menu.todayggigu.rack.usage': '货架使用管理',
  'menu.todayggigu.rack.usage-management': '货架使用管理',
  'menu.todayggigu.rack.information-log': '货架信息日志',
  'menu.todayggigu.statistics': '统计管理',
  'menu.todayggigu.statistics.order': '订单统计',
  'menu.todayggigu.statistics.member': '会员统计',
  'menu.todayggigu.statistics.worker': '工作人员统计',
  'menu.todayggigu.statistics.worker-log': '工作人员日志',
  'menu.todayggigu.statistics.tax-settlement': '税务结算',
  'menu.todayggigu.statistics.purchase-cost': '采购成本统计',
  'menu.todayggigu.statistics.trade-cost': '交易成本统计',
  'menu.todayggigu.statistics.payment-agency': '支付代理统计',
  'menu.todayggigu.solution-inquiry': '解决方案咨询',
  'menu.system': '系统管理',
  'menu.system.admins': '管理员账户',
  'menu.system.roles': '权限管理',
  'menu.system.rates': '汇率/关税设置',
  'menu.system.purchase-condition-settings': '购买条件设置',
  'menu.system.shipping-rate': '配送费率',
  'menu.system.work-log': '工作日志',
  'menu.system.banners': '横幅/广告管理',
  'menu.account': '账户',
  'menu.account.center': '个人资料',
  'menu.account.settings': '设置',
  'menu.account.logout': '退出登录',

  // Trade Services
  'menu.orders.tradeServices': '贸易服务',
  'menu.orders.tradeServices.comprehensive': '综合管理',
  'menu.orders.tradeServices.pendingPayment': '待付款',

  // Payment Agency
  'menu.orders.paymentAgency': '支付代理',
  'menu.orders.paymentAgency.comprehensive': '综合管理',
  'menu.orders.paymentAgency.pendingPayment': '待付款',
  'menu.orders.paymentAgency.forexDepositApplication': '外汇存款申请',
  'menu.orders.paymentAgency.forexDepositUsage': '外汇存款使用',
  'menu.orders.paymentAgency.forexDepositPayment': '外汇存款支付',
};
